var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.b({ green: _vm.amount < 0, red: _vm.amount > 0 })},[_c('span',[_vm._v(_vm._s(_vm.amount > 0 ? '+' : '-'))]),_c('span',[_vm._v("(")]),_c('span',[_vm._v(_vm._s(_vm.render ? _vm.render(Math.abs(_vm.amount)) : Math.abs(_vm.amount)))]),_c('span',[_vm._v(")")])])
}
var staticRenderFns = []

export { render, staticRenderFns }